import React from "react";
import { Button, TextField, makeStyles } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialogTitle-root": {
      paddingBottom: 5,
    },
    "& .MuiDialog-paper": {
      minWidth: "600px",
    },
    "& .MuiTypography-h6": {
      fontWeight: "500",

      color: "#6F6F6F",
      fontSize: "14px",

      fontFamily: "pc_regular !important",
    },
  },
  btn: {
    backgroundColor: "#0071F2",
    borderColor: "#0071F2",
    borderRadius: 8,
    padding: "5px 15px",
    minWidth: 100,
    fontSize: 12,
    color: "#fff",
    "&:hover": {
      backgroundColor: "#0071F2",
    },
  },
  btncancel: {
    backgroundColor: "#fff",
    borderColor: "#0071F2",
    borderRadius: 8,
    padding: "4px 15px",
    minWidth: 100,
    fontSize: 12,
    color: "#0071F2",
    border: "1px solid rgb(0, 113, 242)",
    "&:hover": {
      backgroundColor: "#fff",
    },
  },
}));

function EmailDialog(props) {
  const classes = useStyles();
  const handleClose = () => {
    props.handleClose();
  };

  return (
    <div>
      {/* <Button variant="outlined" color="primary" onClick={}>
        Open alert dialog
      </Button> */}
      <Dialog
        className={classes.root}
        open={props.open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Email Id"}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus={true}
            value={props.value}
            onChange={(e) => props.onChange(e.target.value)}
            type={props.key}
            id={props.id}
            variant={"outlined"}
            fullWidth={true}
            disabled={props.disabled}
            size="small"
            inputProps={{ maxLength: props.maxLength }}
            error={props?.error}
            helperText={props?.error && props?.helperText}
            multiline={props.multiline}
            rows={props.rowsMax}
            placeholder={props.placeholder}
          />
        </DialogContent>
        <DialogActions>
          <Button
            className={classes.btncancel}
            onClick={handleClose}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            className={classes.btn}
            onClick={() => props.handleSend()}
            color="primary"
          >
            {props.loading ? "Sending..." : "Send"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default EmailDialog;
